import React, { useEffect, useRef, useState } from "react";

export function BannerCarousel({ banners = [] }) {
  const ref = useRef(null);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!banners.length) return;
    const t = setInterval(() => {
      setIdx((p) => {
        const n = (p + 1) % banners.length;
        ref.current?.scrollTo({ left: n * ref.current.clientWidth, behavior: "smooth" });
        return n;
      });
    }, 3800);
    return () => clearInterval(t);
  }, [banners.length]);

  const onScroll = () => {
    if (!ref.current) return;
    setIdx(Math.round(ref.current.scrollLeft / ref.current.clientWidth));
  };

  return (
    <div className="px-4">
      <div ref={ref} onScroll={onScroll} className="flex overflow-x-auto hide-scrollbar snap-x-m rounded-2xl" data-testid="banner-carousel">
        {banners.map((b) => (
          <div key={b.id} className="min-w-full snap-start-m relative h-40 rounded-2xl overflow-hidden" style={{ background: b.bg }}>
            <img src={b.image} alt={b.title} className="absolute right-0 top-0 h-full w-1/2 object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent" />
            <div className="relative z-10 p-5 h-full flex flex-col justify-center max-w-[62%]">
              <h3 className="text-white font-display font-extrabold text-xl leading-tight text-balance">{b.title}</h3>
              <p className="text-white/85 text-xs mt-1">{b.subtitle}</p>
              <span className="mt-3 inline-block bg-white text-ink font-bold text-xs px-3 py-1.5 rounded-full w-fit">{b.cta}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-center gap-1.5 mt-2.5">
        {banners.map((_, i) => (
          <span key={i} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-5 bg-coral" : "w-1.5 bg-ink/20"}`} />
        ))}
      </div>
    </div>
  );
}
